import { render } from "./TopSection.vue?vue&type=template&id=60cefc29&scoped=true"
import script from "./TopSection.vue?vue&type=script&lang=js"
export * from "./TopSection.vue?vue&type=script&lang=js"

import "./TopSection.vue?vue&type=style&index=0&id=60cefc29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cefc29"]])

export default __exports__